import posthog from 'posthog-js'

export function initAnalytics() {
  const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined
  if (!key) return
  posthog.init(key, {
    api_host: (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://us.i.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: 'identified_only',
  })
}

export function track(event: string, properties?: Record<string, unknown>) {
  posthog.capture(event, properties)
}

export function identify(userId: string, properties?: Record<string, string | null | undefined>) {
  posthog.identify(userId, properties)
}

export function reset() {
  posthog.reset()
}

export function pageView(url: string) {
  posthog.capture('$pageview', { $current_url: url })
}
